module.exports = __webpack_public_path__ + "img/signpost-split-fill.da0b57a3.svg";